export default __webpack_public_path__ + "static/media/male_pancreas-01.af85c9fb.png";